import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/services/Services.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Services/components/SectionHeader'));
const SectionCards = dynamic(() => import('sections/Services/components/SectionCards'));

export default function Services() {
  return (
    <div className={cn('services')}>
      <SectionHeader />
      <SectionCards />
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Explore DF Alliance Services | DF Alliance',
      description: 'Explore DF Alliance\'s wide range of services designed to streamline your global logistics needs, including digital tools, support, and industry expertise.',
      path: '/services',
    },
  };
};

Services.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
